import { createContext } from 'react';
import { ExperimentationContextValue } from './types';

/**
 * React Context for the Experimentation Client.
 * Provides access to the initialized client and its loading state.
 */
export const ExperimentationContext = createContext<ExperimentationContextValue | undefined>(undefined);

ExperimentationContext.displayName = 'ExperimentationContext';
